// 2024(c) ESIEE Paris
// Author: CANDIA Nicolas <nicolas.candia@esiee.fr>

import bootstrap from "~bootstrap/dist/js/bootstrap.bundle";

const show_toast_message = function() {
    let toastList = [];
    let toastElList = document.querySelectorAll('.toast-message.toast');
    toastList = [...toastElList].map(toastEl => new bootstrap.Toast(toastEl, {}));
    toastList.forEach(element => {
        element.show();
    });
};

export function init() {

    // Show toast message
    show_toast_message();

}